/**
 * @name setDataCounter.js
 * @description [data-num]属性の合計数を取得し、n秒ごとに[data-pos-counter]属性の値を更新する
 * @param {Object} slideLength .slider__list-itemの要素の数
 * @param {Object} dataCurrent .data-pos-counterの要素
 * @param {Object} dataNum [data-num]属性の要素
 * @param {Number} intervalTime n秒ごとに[data-pos-counter]属性の値を更新する間隔
 */
class setDataCounter {
    constructor() {
        this.intervalTime = 4000;
        this.dataSlideCurrent = null;
        this.dataSlide = null;
        this.slideLength = null;
        this.intervalId = null;
        this.__init();
    }

    /**
     * @name __init
     * @description 初期化処理
     */
    __init() {
        this.dataSlideCurrent = document.querySelectorAll("[data-slide-current]");
        if (!this.dataSlideCurrent) return;
        this.__setDataPosCounter()
        this.intervalId = window.setInterval(() => this.__setDataPosCounter(), this.intervalTime);
    }

    /**
     * @name __itemClassSetting
     * @description [data-number]属性の値と[data-current]属性の値が一致する場合、currentクラスを付与する
     * @param {Object} item [data-number]属性の要素
     */
    __itemClassSetting = (item, currentEl) => {
        item.dataset.slide === currentEl.dataset.slideCurrent ? item.classList.add("current") : item.classList.remove("current");
    }

    /**
     * @name __setDataPosCounter
     * @description [data-pos-counter]属性の値を更新する
     */
    __setDataPosCounter = () => {
        this.dataSlideCurrent.forEach(el => {
            this.dataSlide = el.querySelectorAll("[data-slide]");
            this.slideLength = this.dataSlide.length.toString();

            let dataPos = el.dataset.slideCurrent;

            dataPos === this.slideLength ? el.dataset.slideCurrent = "1" : el.dataset.slideCurrent++;
            this.dataSlide.forEach(item => this.__itemClassSetting(item, el));
        });
    }
};

export default setDataCounter;